import { CancelTokenSource } from 'axios'
import { VuexModule, Module, Action } from 'vuex-class-modules'
import { Classifiers as ClassifiersData, Classifier } from '@/commons/types'
import { VuexRegisterGlobals } from '@/store/decorators/vuex.register.globals'
import { ObjectUtils } from '@/commons/utils/objects'

@VuexRegisterGlobals({
    actionParams: [{
        targetActionName: 'clearAll',
        contextActionName: 'clear'
    }]
})
@Module({ generateMutationSetters: true })
export default class Classifiers extends VuexModule {
    requestCancelToken: CancelTokenSource | null = null
    classifiers: ClassifiersData | null = null

    get isValidClassifiers (): boolean {
        return !ObjectUtils.isEmpty(this.classifiers)
    }

    get countries (): Array<Classifier> {
        return this.classifiers?.riik || []
    }

    get applicationReasons (): Array<Classifier> {
        return this.classifiers?.taotl_pohjus || []
    }

    get placeOfBirths (): Array<Classifier> {
        return this.classifiers?.synnikoht || []
    }

    get educations (): Array<Classifier> {
        return this.classifiers?.haridus || []
    }

    get nationalities (): Array<Classifier> {
        return this.classifiers?.rahvus || []
    }

    get nativeLanguages (): Array<Classifier> {
        return this.classifiers?.keel || []
    }

    get placeOfIssueGroups (): Array<Classifier> {
        return this.classifiers?.place_of_issue_group || []
    }

    get foreignPlacesOfIssues (): Array<Classifier> {
        return this.filterPlacesOfIssues(this.classifiers?.valis_esindus || [])
    }

    get localPlacesOfIssues (): Array<Classifier> {
        return this.filterPlacesOfIssues(this.classifiers?.byroo_aadress || [])
    }

    get consulPlacesOfIssuesIdCard (): Array<Classifier> {
        return this.filterPlacesOfIssues(this.classifiers?.aukonsul_id || [])
    }

    get consulPlacesOfIssuesCitizenPassport (): Array<Classifier> {
        return this.filterPlacesOfIssues(this.classifiers?.aukonsul_pass || [])
    }

    get stpPlacesOfIssues (): Array<Classifier> {
        return this.filterPlacesOfIssues(this.classifiers?.stp_aadress || [])
    }

    filterPlacesOfIssues (placesOfIssues: Array<Classifier>): Array<Classifier> {
        return placesOfIssues.filter(classifier => !classifier.label.includes('ÄRA KASUTA')) || []
    }

    @Action
    clear (): void {
        this.requestCancelToken = null
        this.classifiers = null
    }
}
